import React from 'react'
import PropTypes from 'prop-types';
import BaseComponent from 'common/BaseComponent.js'
import theme from './Popup.scss'

export default class Popup extends BaseComponent {

    /**
     * Show popup if visible is true.
     */
    render() {
        if (this.props.visible) {
            return (
                <div className={theme.popupWrapper}>
                    {this.props.children}
                </div>
            );
        } else {
            return null;
        }
    }
}

Popup.propTypes = {

    /**
     * Boolean flag. Used for show popup.
     */
    visible: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/common/Popup/index.js